export default "__VITE_ASSET__D1VJy7Br__"